import { AfterViewInit, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { TextBoxDirective } from '@progress/kendo-angular-inputs';
@Component({
    selector: 'gd-rvtextbox',
    styleUrls: ['./../Rvfieldbuilder/test.css'],
    template: `
    <div [formGroup]="form" class="form-group has-error spacing">
      <input
        [disabled]="field.disabled"
        [attr.type]="field.type"
        kendoTextBox
        class="form-control"
        [id]="field.name"
        [name]="field.name"
        [formControlName]="field.name"
      />
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TextBoxDirective,
    ]
})
export class RvTextBoxComponent implements AfterViewInit {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  ngAfterViewInit(): void {
    this.form.markAllAsTouched()
  }
  get isValid() {
    return this.form.controls[this.field.name].valid
  }
  get isDirty() {
    return this.form.controls[this.field.name].dirty
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    if (
      this.field.name.toLowerCase() === 'amount'.toLowerCase() ||
      this.field.name.toLowerCase() === 'NetWorth'.toLowerCase() ||
      this.field.name.toLowerCase() === 'LiquidNetWorth'.toLowerCase() ||
      this.field.name.toLowerCase() === 'PremiumAmount'.toLowerCase()
    ) {
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false
      }
      return true
    }
    return null;
  }
  private markFormGroupTouched(formGroup: UntypedFormGroup) {
    ;(<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched()

      if (control.controls) {
        this.markFormGroupTouched(control)
      }
    })
  }
}
